<template>
    <article id="chat-layout" @mousemove="clearTitle" :class="[{'rolled-out': isRolledOut}]">
        <template v-if="!fetchingLoginStatus && isLoggedIn">
            <chat-side-panel></chat-side-panel>
            <chat-panel></chat-panel>
            <active-chats-panel></active-chats-panel>
        </template>
    </article>
</template>

<script>
    import ChatSidePanel from '../Chatroom/ChatSidePanel.vue'
    import ActiveChatsPanel from '../Chatroom/ActiveChatsPanel.vue'
    import ChatPanel from '../ChatRoom/ChatPanel.vue';

    import axios from 'axios';

    export default {
        name: 'ChatLayout',
        components: {
            'chat-side-panel': ChatSidePanel,
            'active-chats-panel': ActiveChatsPanel,
            'chat-panel': ChatPanel
        },

        computed: {
            fetchingLoginStatus(){
                return !this.$store.state.loggedUserModel.gotInitialLoggedUserInfo;
            },

            isLoggedIn(){
                return this.$store.state.loggedUserModel.isLoggedIn;
            },

			isRolledOut(){
				return this.$store.state.chatroomConfigModel.fullSidePanelMode;
			}
        },

        methods: {
            'clearTitle'(){
                if (this.$store.state.titleBarModel.alert) {
                    this.$store.state.titleBarModel.alert = undefined;
                }
            }
        },
        mounted(){
            this.$store.commit('activeChatModel/setActiveChat', 'public.1');
            this.$store.dispatch('ignoredUsersModel/fetchIgnoredUsers');
        },

        sockets: {
            'returnToPublic'(){
                this.$store.commit('activeChatModel/setActiveChat', 'public.1');
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ChatLayout.vue?b33664de